import React from 'react';

import * as S from './styles';

const Header: React.FC = () => {
  return (
    <S.Container
      className="wow animate__animated animate__fadeIn"
      data-wow-duration="1s"
      data-wow-delay="400ms"
    >
      <S.HeaderDesktop />
      <S.HeaderMobile />
      <S.Caption>
        <p className="desktop">
          Representação do cowboy americano no desfile de verão 2023 de Thom
          Browne. Getty Images.
        </p>
        <p className="mobile">
          Abre: Thom Browne, verão 2023 | Foto: Getty Images
        </p>
      </S.Caption>
    </S.Container>
  );
};

export default Header;
